import commonUtils from '../../../utils/commonUtils';
import { defaultResult, validatorWithMsg } from '../../../utils/Validator';

class PickerHelper {
  initState(props: any) {
    const { defaultValue, value } = props;
    let state: any = { result: defaultResult };
    if (value === undefined) {
      state = { result: defaultResult, pickerValue: defaultValue || undefined };
    }    
    return state;
  }
  validatorWithMsg(props: any, state: any, val?: any) {
    const { title, rules = [], required, requiredMsg, value } = props;
    let newRules = commonUtils.deep(rules);
    if (required) {
      newRules.unshift({
        required,
        message: requiredMsg || '请选择' + (title || '内容')
      });
    }
    const { pickerValue } = state;
    return validatorWithMsg(val || (value === undefined ? pickerValue : value), newRules);
  }
}
export default PickerHelper;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSDatePicker/helper/pickerHelper.ts